import { Link } from "react-router-dom";
import { MdSwapHorizontalCircle } from "react-icons/md";
import instagram from "../../assets/img/instagram.png";
import facebook from "../../assets/img/facebook.png";
import linkdin from "../../assets/img/linkedin.png";

const KLV_LOGO = "https://kleverscan.org/assets/klv-logo.png";

const Footer = () => {
  return (
    <div className="py-[46px] bg-[#3B1F7E] relative overflow-hidden">
      {/* Subtle top border glow */}
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#E71CA5] to-transparent opacity-40" />

      <div className="main-container flex flex-col">
        <Link
          to="/shitswap"
          className="mx-auto mb-6 flex items-center gap-2 bg-[#E71CA5] hover:bg-[#E71CA5]/90 text-white font-Poppins font-bold text-sm md:text-base px-6 py-3 rounded-full shadow-glow-pink transition-all hover:scale-105"
        >
          <MdSwapHorizontalCircle className="text-xl" />
          Swap on ShitSwap
        </Link>
        <div className="m-auto flex gap-6">
          {icons.map(({ id, icon, path }) => {
            return (
              <a
                href={path}
                target="_blank"
                rel="noreferrer"
                key={id}
                className="w-[49px] md:w-[72px] h-[49px] md:h-[72px] rounded-full bg-white/10 backdrop-blur-sm border border-white/20 flex items-center justify-center hover-lift hover:bg-white/20 transition-all duration-300 hover:shadow-glow-pink"
              >
                {icon}
              </a>
            );
          })}
        </div>
        <div className="text-center text-lg mt-8 text-white/80 font-Poppins">
          &copy; {new Date().getFullYear()} Shiny Heffers — All Rights Reserved
        </div>
        <div className="text-center text-sm mt-2 text-white/40 font-Rajdhani">
          Dual-chain: BSC + KleverChain
        </div>
      </div>
    </div>
  );
};

export default Footer;

const icons = [
  {
    id: 1,
    path: "https://www.instagram.com/shinyheffers/",
    icon: (
      <img
        src={instagram}
        alt="Instagram"
        className="w-[24px] h-[24px] md:w-[36px] md:h-[36px]"
      />
    ),
  },
  {
    id: 2,
    path: "https://www.facebook.com/shinyheffers",
    icon: (
      <img
        src={facebook}
        alt="Facebook"
        className="w-[14px] h-[27px] md:w-[21px] md:h-[40px]"
      />
    ),
  },
  {
    id: 3,
    path: "https://www.linkedin.com/company/shinyheffers",
    icon: (
      <img
        src={linkdin}
        alt="LinkedIn"
        className="w-[26px] h-[26px] md:w-[38px] md:h-[38px]"
      />
    ),
  },
  {
    id: 4,
    path: "https://bscscan.com/token/0x18c8845Af8Bc9669b2F3af2462567cE35263C34a#code",
    icon: (
      <img
        src="https://tokens.pancakeswap.finance/images/symbol/bnb.png"
        alt="View SHIT on BscScan"
        className="w-[26px] h-[26px] md:w-[38px] md:h-[38px] rounded-full"
      />
    ),
  },
  {
    id: 5,
    path: "https://kleverscan.org/asset/SHIT-3UF0",
    icon: (
      <img
        src={KLV_LOGO}
        alt="View SHIT on KleverScan"
        className="w-[26px] h-[26px] md:w-[38px] md:h-[38px] rounded-full"
      />
    ),
  },
];
